/* istanbul ignore file */

export enum SaveReportViewButtonStateEnum {
    SaveOrUpdateCurrent = 'saveOrUpdateCurrent',
    None = 'none',
    SaveFromDefault = 'saveFromDefault',
}
